<template>
  <div>
    <Field
      v-slot="{ errors, field, value }"
      v-model.number="_seats"
      as="div"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@COUVERT_NUMBER'))"
      :rules="{ numeric: true }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        type="number"
        :label="$t('ETAB.FORMS.LABELS.@COUVERT_NUMBER')"
        :name="iModel.seats"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>
  </div>
</template>

<script>
  import { Field } from "vee-validate";
  export default {
    components: {
      Field,
    },
    props: {
      seats: { type: Number, default: 0 },
      iModel: { type: Object, default: () => ({}) },
    },
    emits: ["update:seats"],
    computed: {
      _seats: {
        get() {
          return this.seats;
        },
        set(value) {
          this.$emit("update:seats", value);
        },
      },
    },
  };
</script>
